<!-- hidden measurer used by placeholder width checks -->
<div id="placeholderMeasurer" class="invisible absolute whitespace-pre" aria-hidden="true"></div>

<!-- COURT OF APPEAL DETAILS -->
<form [formGroup]="courtOfAppealForm"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-2">

  <h4 class="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 text-lg font-semibold mb-2" *ngIf="!isAddReadonly">
    Appeal Additional Details
  </h4>

  <div class="flex flex-col">
    <label class="required-label">Court Below</label>
    <ng-container *ngIf="!isAddReadonly; else courtReadonly">
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('courtOfAppeal')?.value?.name || '-'">
      </mat-form-field>
    </ng-container>
    <ng-template #courtReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('courtOfAppeal')?.value?.name || '-'">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Division at Court of Appeal</label>
    <ng-container *ngIf="!isAddReadonly && !courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value; else divisionReadonly">
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="divisionAtCourtOfAppeal"
          [disabled]="isAddReadonly"
          (openedChange)="onDivisionDropdownOpened()"
          [compareWith]="compareById"
          (selectionChange)="onCourtOfAppealDivisionSelected($event.value)">
          <ngx-mat-select-search
            [formControl]="divisionSearchCtrl"
            placeholderLabel="Search divisions..."
            noEntriesFoundLabel="No division found">
          </ngx-mat-select-search>

          <mat-option *ngIf="isCoaDivisionLoading" disabled class="flex items-center gap-2">
          <mat-progress-spinner diameter="18" mode="indeterminate"></mat-progress-spinner>
          <span>Loading divisions…</span>
        </mat-option>
        <ng-container *ngIf="!isCoaDivisionLoading">
          <mat-option *ngFor="let division of filteredDivisions" [value]="division">
            {{ division.name }}
          </mat-option>
          <mat-option *ngIf="filteredDivisions.length === 0" disabled>
            -- No Divisions found --
          </mat-option>

          <mat-option *ngIf="allowAddDivision && divisionSearchCtrl.value && !(filteredDivisions.length)"
                      (click)="addNewDivision(divisionSearchCtrl.value)">
            <span style="color: green;">➕</span> Add "{{ divisionSearchCtrl.value }}"
          </mat-option>
          </ng-container> 
        </mat-select>
          <mat-progress-spinner
        *ngIf="isCoaDivisionLoading"
        matSuffix
        mode="indeterminate"
        diameter="18">
      </mat-progress-spinner>
      </mat-form-field>
    </ng-container>
    <ng-template #divisionReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value?.name || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Court of Appeal Case No.</label>
    <ng-container *ngIf="!isAddReadonly && !initialData?.lowerCourtCaseNo; else coaCaseNoReadonly">
      <mat-form-field appearance="outline">
        <input matInput formControlName="courtOfAppealCaseNo" />
      </mat-form-field>
    </ng-container>
    <ng-template #coaCaseNoReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('courtOfAppealCaseNo')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <!-- Panel of Justices -->
  <div class="flex flex-col relative trial-judge-wrapper">
    <label class="required-label flex items-center"><span>Panel of Justices</span>

  <!-- focusable for keyboard users -->
  <span
    matTooltip="Enter Justice Full Name"
    matTooltipPosition="right"
    tabindex="0"
    aria-label="Enter Justice Full Name"
    class="cursor-pointer leading-none"
    *ngIf="!isAddReadonly"
  >
    <mat-icon>info</mat-icon>
  </span></label>

    <!-- fetched results on search -->
    <div *ngIf="(typedJustice?.length ?? 0) >= 4 && !isAddReadonly"
         class="justice-dropdown bg-white border border-gray-300 rounded mt-1 shadow z-40 max-h-40 overflow-y-auto">
      <div *ngIf="isJusticeLoading" class="flex items-center justify-center p-2">
        <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
      </div>
      <div *ngIf="!isJusticeLoading && filteredJustices?.length">
        <div *ngFor="let justice of filteredJustices"
             (click)="selectJustice(justice)"
             class="py-1 px-2 hover:bg-blue-50 cursor-pointer border-b last:border-0">
          {{ justice.name }}
        </div>
      </div>
      <div *ngIf="!isJusticeLoading && !(filteredJustices?.length)">
        <div class="text-gray-500 italic p-2">No justices found</div>
      </div>
    </div>

    <!-- Editable Mode -->
    <ng-container *ngIf="!isAddReadonly; else readonlyPanelOfJustices">
      <div
        class="justice-input-wrapper flex items-center border border-gray-400 rounded bg-white px-2 py-1 shadow-sm"
        style="height: 34px;">
        <input
          id="justiceInput"
          type="text"
          [(ngModel)]="typedJustice"
          (ngModelChange)="onJusticeInputChange()"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="currentPlaceholder"
          class="flex-1 outline-none border-none bg-transparent text-sm" />

        <button mat-icon-button color="primary" (click)="toggleExpand()">
          <mat-icon>{{ isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <button mat-icon-button color="accent"
                (click)="addTypedJustice()"
                *ngIf="typedJustice?.trim() && !filteredJustices?.length && !isJusticeLoading">
          <mat-icon>add</mat-icon>
        </button>

        <div *ngIf="isJusticeLoading && typedJustice?.trim() && !filteredJustices?.length" class="mr-2">
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        </div>
      </div>

      <!-- Expanded List (Editable Mode) -->
      <div *ngIf="isExpanded && (!typedJustice || typedJustice.length < 4)"
           class="justice-dropdown bg-white border border-gray-300 rounded mt-1 shadow z-40 max-h-40 overflow-y-auto">
        <div *ngIf="panelOfJustices.length; else noPanelJustices">
          <div *ngFor="let justice of panelOfJustices"
               class="flex justify-between items-center py-1 px-2 border-b last:border-0">
            <span>{{ justice.name }}</span>
            <button mat-icon-button color="warn" (click)="removeJustice(justice)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <ng-template #noPanelJustices>
          <div class="text-gray-500 italic p-2">No justices added yet</div>
        </ng-template>
      </div>
    </ng-container>

    <!-- Readonly Mode -->
    <ng-template #readonlyPanelOfJustices>
      <div
        class="justice-input-wrapper flex items-center border border-gray-400 rounded bg-gray-100 px-2 py-1 shadow-sm"
        style="height: 34px;">
        <input
          matInput
          readonly
          class="flex-1 outline-none border-none bg-transparent"
          [value]="getNames(courtOfAppealForm.get('panelOfJustices')?.value)" />
        <button
          mat-icon-button
          color="primary"
          *ngIf="(courtOfAppealForm.get('panelOfJustices')?.value?.length ?? 0) > 1"
          (click)="openJusticesDialog(courtOfAppealForm.get('panelOfJustices')?.value || [], true)"
          [disableRipple]="true">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Date of Appeal Court Judgment</label>
    <ng-container *ngIf="!isAddReadonly; else dateReadonly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="judgmentPicker" formControlName="appealCourtJudgmentDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="judgmentPicker"></mat-datepicker-toggle>
        <mat-datepicker #judgmentPicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #dateReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('appealCourtJudgmentDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label [class.required]="isRequired(courtOfAppealForm, 'noticeOfAppealFiledDate')">Date Notice of Appeal Filed</label>
    <ng-container *ngIf="!isAddReadonly; else noticeOfAppDateReadonly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="noticePicker" formControlName="noticeOfAppealFiledDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="noticePicker"></mat-datepicker-toggle>
        <mat-datepicker #noticePicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #noticeOfAppDateReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('noticeOfAppealFiledDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label [class.required]="isRequired(courtOfAppealForm, 'transmissionOfRecordDate')">Date of Transmission of Record </label>
    <ng-container *ngIf="!isAddReadonly; else transofRecordReadonly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="transmissionPicker" formControlName="transmissionOfRecordDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="transmissionPicker"></mat-datepicker-toggle>
        <mat-datepicker #transmissionPicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #transofRecordReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('transmissionOfRecordDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label [class.required]="isRequired(courtOfAppealForm, 'serviceOfAppealRecordDate')">Date of Service of Appeal Record</label>
    <ng-container *ngIf="!isAddReadonly; else dosAppealRecordPartReadOnly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="servicePicker" formControlName="serviceOfAppealRecordDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="servicePicker"></mat-datepicker-toggle>
        <mat-datepicker #servicePicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #dosAppealRecordPartReadOnly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="courtOfAppealForm.get('serviceOfAppealRecordDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 flex flex-wrap items-center gap-x-2">
    <ng-container *ngIf="!isAddReadonly; else toggleReadonly">
      <mat-slide-toggle formControlName="supplementaryRecordFiled" class="h-6 leading-6 text-sm" style="min-height: 1.5rem;">
        Was Supplementary Record Filed?
      </mat-slide-toggle>
    </ng-container>
    <ng-template #toggleReadonly>
      <div class="readonly-toggle">
        <label class="text-sm mr-2">Was Supplementary Record Filed?</label>
        <span class="readonly-switch" [class.active]="courtOfAppealForm.get('supplementaryRecordFiled')?.value">
          {{ courtOfAppealForm.get('supplementaryRecordFiled')?.value ? 'Yes' : 'No' }}
        </span>
      </div>
    </ng-template>

    <div *ngIf="courtOfAppealForm.get('supplementaryRecordFiled')?.value ?? false"
         class="flex flex-col w-full sm:w-auto">
      <label class="required-label">Date of Supplementary Record</label>
      <ng-container *ngIf="!isAddReadonly; else dosupplementryRecordReadonly">
        <mat-form-field appearance="outline" class="w-full sm:w-72">
          <input matInput [matDatepicker]="supplementaryPicker" formControlName="supplementaryRecordDate" [max]="today" />
          <mat-datepicker-toggle matSuffix [for]="supplementaryPicker"></mat-datepicker-toggle>
          <mat-datepicker #supplementaryPicker></mat-datepicker>
        </mat-form-field>
      </ng-container>
      <ng-template #dosupplementryRecordReadonly>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput [readonly]="true" [disabled]="true"
                 [value]="courtOfAppealForm.get('supplementaryRecordDate')?.value || ''">
        </mat-form-field>
      </ng-template>
    </div>
  </div>
</form>

<!-- TRIAL COURT DETAILS -->
<form [formGroup]="trialCourtForm" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-2">
  <h4 class="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 text-lg font-semibold mb-2 mt-8" >
    
    Trial Court Details
  </h4>

  <div class="flex flex-col">
    <label class="required-label">Trial Court Name</label>
    <ng-container *ngIf="!isAddReadonly; else trailCourtReadonly">
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="trialCourt"
          [disabled]="isAddReadonly"
          (openedChange)="onTrialCourtDropdownOpened()"
          [compareWith]="compareById"
          (selectionChange)="onTrialCourtSelected($event.value)">
          <ngx-mat-select-search
            [formControl]="trialCourtSearchCtrl"
            placeholderLabel="Search trial courts..."
            noEntriesFoundLabel="No court found">
          </ngx-mat-select-search>

          <mat-option *ngFor="let court of filteredTrialCourts" [value]="court">
            {{ court.name }}
          </mat-option>
          <mat-option *ngIf="filteredTrialCourts.length === 0" disabled>
            -- No Courts found --
          </mat-option>

          <mat-option *ngIf="allowAddTrialCourt && trialCourtSearchCtrl.value && !(filteredTrialCourts.length)"
                      (click)="addNewTrialCourt(trialCourtSearchCtrl.value)">
            <span style="color: green;">➕</span> Add "{{ trialCourtSearchCtrl.value }}"
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-template #trailCourtReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="trialCourtForm.get('trialCourt')?.value?.name || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Court</label>
    <ng-container *ngIf="!isAddReadonly; else trialDivisionReadonly">
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="trialCourtDivision"
          [disabled]="isAddReadonly"
          (openedChange)="onTrialDivisionDropdownOpened()"
          [compareWith]="compareById"
          (selectionChange)="onTrialDivisionSelected($event.value)">
          <ngx-mat-select-search
            [formControl]="trialDivisionSearchCtrl"
            placeholderLabel="Search divisions..."
            noEntriesFoundLabel="No division found">
          </ngx-mat-select-search>

          <mat-option *ngFor="let division of filteredTrialDivisions" [value]="division">
            {{ division.name }}
          </mat-option>
          <mat-option *ngIf="filteredTrialDivisions.length === 0" disabled>
            -- No Division found --
          </mat-option>

          <mat-option *ngIf="allowAddTrialDivision && trialDivisionSearchCtrl.value && !(filteredTrialDivisions.length)"
                      (click)="addNewTrialDivision(trialDivisionSearchCtrl.value)">
            <span style="color: green;">➕</span> Add "{{ trialDivisionSearchCtrl.value }}"
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-template #trialDivisionReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="trialCourtForm.get('trialCourtDivision')?.value?.name || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col relative">
    <label class="required-label flex items-center">
      
      <span>Judge at Trial Court</span>

      <!-- focusable for keyboard users -->
      <span
        matTooltip="Enter Judge Full Name"
        matTooltipPosition="right"
        tabindex="0"
        aria-label="Enter Judge Full name"
        class="cursor-help"
        *ngIf="!isAddReadonly"
      >
        <mat-icon>info</mat-icon>
      </span>
    </label>


    <!-- Editable Mode -->
    <ng-container *ngIf="!isAddReadonly; else readonlyTrialJudge">
      <div
        class="justice-input-wrapper flex items-center border border-gray-400 rounded bg-white px-2 py-0 shadow-sm"
        style="height: 34px; position: relative; overflow:visible">
        <input
          id="trialJudgeInput"
          type="text"
          [(ngModel)]="typedTrialJudge"
          (ngModelChange)="onTrialJudgeInputChange()"
          [ngModelOptions]="{ standalone: true }"
          [placeholder]="currentTrialJudgePlaceholder"
          class="flex-1 outline-none border-none bg-transparent text-sm" />

        <button mat-icon-button color="primary" (click)="isTrialJudgeExpanded = !isTrialJudgeExpanded">
          <mat-icon>{{ isTrialJudgeExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        <button mat-icon-button color="accent"
                (click)="addTypedTrialJudge()"
                *ngIf="typedTrialJudge?.trim() && !filteredTrialJudges?.length && !isTrialJudgeLoading">
          <mat-icon>add</mat-icon>
        </button>

        <div *ngIf="isTrialJudgeLoading && typedTrialJudge?.trim() && !filteredTrialJudges?.length" class="mr-2">
          <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
        </div>
      </div>

      <!-- fetched results on search -->
      <div *ngIf="(typedTrialJudge?.length ?? 0) >= 4 && !isAddReadonly"
           class="justice-dropdown bg-white border border-gray-300 rounded mt-1 shadow z-30 max-h-[30vh] overflow-y-auto">
        <div *ngIf="isTrialJudgeLoading" class="flex items-center justify-center p-2">
          <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
        </div>

        <div *ngIf="!isTrialJudgeLoading && filteredTrialJudges?.length">
          <div *ngFor="let judge of filteredTrialJudges"
               (click)="selectTrialJudge(judge)"
               class="py-1 px-2 hover:bg-gray-100 cursor-pointer border-b last:border-0">
            {{ judge.name }}
          </div>
        </div>

        <div *ngIf="!isTrialJudgeLoading && !(filteredTrialJudges?.length)">
          <div class="text-gray-500 italic p-2">No judges found</div>
        </div>
      </div>

      <!-- Expanded List (Editable Mode) -->
      <div *ngIf="isTrialJudgeExpanded && (!typedTrialJudge || typedTrialJudge.length < 4)"
           class="justice-dropdown bg-white border border-gray-300 rounded mt-1 shadow z-40 max-h-40 overflow-y-auto">
        <div *ngIf="selectedTrialJudges.length; else noTrialJudgeData">
          <div *ngFor="let judge of selectedTrialJudges"
               class="flex justify-between items-center py-1 px-2 border-b last:border-0">
            <span>{{ judge.name }}</span>
            <button mat-icon-button color="warn" (click)="removeTrialJudge(judge)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <ng-template #noTrialJudgeData>
          <div class="text-gray-500 italic p-2">No judges added yet</div>
        </ng-template>
      </div>
    </ng-container>

    <!-- Read-only Mode -->
    <ng-template #readonlyTrialJudge>
      <div
        class="justice-input-wrapper flex items-center border border-gray-400 rounded bg-gray-100 px-2 py-1 shadow-sm"
        style="height: 34px;">
        <input
          matInput
          readonly
          class="flex-1 outline-none border-none bg-transparent"
          [value]="getNames(trialCourtForm.get('trialJudge')?.value)" />
        <button
          mat-icon-button
          *ngIf="isAddReadonly && (trialCourtForm.get('trialJudge')?.value?.length ?? 0) > 1"
          (click)="openJusticesDialog(trialCourtForm.get('trialJudge')?.value || [], false)"
          [disableRipple]="true">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Date of Trial Court Judgment</label>
    <ng-container *ngIf="!isAddReadonly; else dateofTrialJudgementReadonly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="trialDatePicker" formControlName="trialCourtJudgementDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="trialDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #trialDatePicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #dateofTrialJudgementReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="trialCourtForm.get('trialCourtJudgementDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>

  <div class="flex flex-col">
    <label class="required-label">Date of Service of Appellants</label>
    <ng-container *ngIf="!isAddReadonly; else dosAppellantsReadonly">
      <mat-form-field appearance="outline">
        <input matInput [matDatepicker]="appellantDatePicker" formControlName="serviceOfAppellantsDate" [max]="today" />
        <mat-datepicker-toggle matSuffix [for]="appellantDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #appellantDatePicker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-template #dosAppellantsReadonly>
      <mat-form-field appearance="outline" class="w-full">
        <input matInput [readonly]="true" [disabled]="true"
               [value]="trialCourtForm.get('serviceOfAppellantsDate')?.value || ''">
      </mat-form-field>
    </ng-template>
  </div>
</form>
